import { LineItemsInOrderText, SearchItemText } from "constants/text";
import { SyntheticEvent, useMemo } from "react";
import SuggestedSearch from "components/Common/SuggestedSearch/SuggestedSearch";
import { OrderDetailsSearchLineItemsWrapper } from "components/OrderDetailsLineItem/OrderDetailsSearchLineItems.styles.ts";

interface SearchLineItemsProps {
	groupAllByNoneTrackingNumber: any;
	searchValue?: string | null;
	handleOrderSearch: (event: SyntheticEvent, values: string) => void;
	lineItemAndShipmentCount?: number;
}

const OrderDetailsSearchLineItems = ({
	groupAllByNoneTrackingNumber,
	searchValue,
	handleOrderSearch,
	lineItemAndShipmentCount
}: SearchLineItemsProps) => {
	const searchOptions = useMemo(() => {
		return groupAllByNoneTrackingNumber?.map(
			(order: { sku: string; description: string }) => order?.sku + " " + order?.description
		);
	}, [groupAllByNoneTrackingNumber]);

	return (
		<OrderDetailsSearchLineItemsWrapper className="line-item-header">
			<span data-testid="orderDetails-lineItem-count">
				{lineItemAndShipmentCount} {LineItemsInOrderText}
			</span>

			<SuggestedSearch
				ariaLabel="search-orders"
				dataTestId="orderDetails-lineItem-search"
				dropDownOpenOnChar={3}
				placeholder={SearchItemText}
				handleSearch={(event, values) => handleOrderSearch(event, (values as string) ?? "")}
				id="replacements-search-line-items"
				searchOptions={searchOptions ?? []}
				searchValue={searchValue ?? ""}
				size="small"
			/>
		</OrderDetailsSearchLineItemsWrapper>
	);
};

export default OrderDetailsSearchLineItems;
